export const styles = {
  container: {
    padding: "10px 8px",
    display: "flex",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  text: {
    color: "#183053",
    fontWeight: 500,
    fontSize: 14,
  },
  pageSize: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #183053",
    borderRadius: 6,
    padding: "6px 16px",
    minWidth: 100,
  },
  arrow: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  upArrowIcon: {
    width: 6,
    height: 8,
    cursor: "pointer",
    transform: "rotate(-90deg)",
  },
  downArrowIcon: {
    width: 6,
    height: 8,
    cursor: "pointer",
    transform: "rotate(90deg)",
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.4,
  },
};
